import React from 'react'
import MaterialSelect from '../../../../../../components/MasterSelect';
import MaterialInput from '../../../../../../components/MaterialInput';
import { Add, Delete, Key } from '@mui/icons-material';
import MaterialTypography from '../../../../../../components/MaterialTypography';
import { Divider, InputAdornment } from '@mui/material';
import Grid from '@mui/material/Grid2'
import MaterialButton from '../../../../../../components/MaterialButton';
import PercentIcon from '@mui/icons-material/Percent';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import MaterialBox from '../../../../../../components/MaterialBox';
import Popper from '@mui/material/Popper';
import { useUserDetails } from '../../../../../../context/auth';
import { toast } from "react-toastify";
const SalaryStructureInformationTable = ({ index, salaryedit,componentList, tableData, confirmDelete, onAddRow, getEarningValue, onDataChange, type }) => {
    console.log('componentList:',componentList);
    console.log('tableData:',tableData);
    const {viewcomponent} = useUserDetails()
    
    return (
        <MaterialBox>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <MaterialTypography
                            component="label"
                               variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                        >
                            Component
                        </MaterialTypography>
                    </MaterialBox>
                </Grid>
                <Grid size={{ xs: 12, md: 2.5 }}>
                    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block" >
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                        >
                            Percentage
                        </MaterialTypography>
                    </MaterialBox>
                </Grid>

                <Grid size={{ xs: 12, md: 2.5 }}>
                    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block" >
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                        >
                            Amount
                        </MaterialTypography>
                    </MaterialBox>
                </Grid>

                <Grid size={{ xs: 12, md: 2 }}>
                    <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                        >
                            Calculated from
                        </MaterialTypography>
                    </MaterialBox>
                </Grid>

                <Grid size={{ xs: 12, md: 1 }}>
                </Grid>
            </Grid>

            {
                tableData.map((earn) => (
                    <MaterialBox key={earn.id}>
                        <Grid container spacing={2} mb={1}>
                            <Grid size={{ xs: 12, md: 4 }}>
                                
                                <MaterialSelect
                                    menuPlacement="auto"
                                    // isClearable
                                    // disabled={salaryedit === true ? true : false}
                                    label="Select component"
                                    // isDisabled={viewcomponent}
                                    onClick={() => alert("You can't edit the component")}

                                    customStyles={{
                                        // optionPadding: 1
                                        paddingDisabled: true,
                                    }}
                                    value={earn.component ? earn.component :"" }
                                    onChange={(e) => {
                                        console.log('Selected value:', e);
                                        onDataChange('component', e, earn.id, type)
                                    }}
                                    options={
                                        componentList
                                            .filter((component) => {
                                                return !tableData.some(rowItem => rowItem.component?.value === component.componentName) ||
                                                    earn.component?.value === component.componentName
                                            }
                                            )
                                            .map((component) => {
                                                return {
                                                      Key : component.id  ,
                                                    value: component.componentName,
                                                    label: component.componentName
                                                }
                                            })
                                    }
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 2.5 }}>
                                <MaterialInput
                                    name="percentage"
                                    placeholder="Percentage"
                                    value={earn.percentage }
                                    disabled={componentList.find(component => component.componentName === earn.component?.value)?.calculatedIn == 'amount'}
                                    onChange={(e) => {
                                        onDataChange('percentage', e.target.value, earn.id, type)
                                    }}
                                    icon={{
                                        direction: "right",
                                        component: (
                                            <PercentIcon size={18} color='black' />
                                        )
                                    }}
                                />
                            </Grid>

                            <Grid size={{ xs: 12, md: 2.5 }}>
                                <MaterialInput
                                    name="amount"
                                    placeholder="Amount"
                                    value={componentList.find(component => component.componentName === earn.component?.value)?.calculatedIn == 'percentage' ? '' : earn.amount ? earn.amount : ''}
                                    disabled={componentList.find(component => component.componentName === earn.component?.value)?.calculatedIn == 'percentage'}
                                    onChange={(e) => {
                                        onDataChange('amount', e.target.value, earn.id, type)
                                    }}
                                    // startAdornment={<InputAdornment position="end">₹</InputAdornment>}
                                    icon={{
                                        direction: "right",
                                        component: (
                                            <CurrencyRupeeIcon size={18} color='black' />
                                        )
                                    }}
                                />
                            </Grid>

                            <Grid size={{ xs: 12, md: 2 }}>
                                <MaterialInput
                                    disabled
                                    value={earn.component ? componentList.find(component => component.componentName === earn.component?.value)?.calculatedFrom : ""}
                                />
                            </Grid>

                            <Grid size={{ xs: 12, md: 1 }}>
                                <MaterialButton onClick={() => {
                                    confirmDelete(earn.id);
                                }}
                                    variant="gradient"
                                    color="error"
                                    disabled={salaryedit === true ? true : false}
                                >
                                    <Delete color="inherit" />
                                </MaterialButton>
                            </Grid>
                        </Grid>
                        <Divider
                            style={{
                                marginTop: 1,
                            }}
                        />
                    </MaterialBox>
                ))
            }
            

        </MaterialBox >
    )
}

export default SalaryStructureInformationTable
